// ConvertToCanon/artstyles/FauvismStyle.js
export const applyFauvismStyle = async (canvas, ctx, setMessage, language) => {
  // 야수파: 강렬한 색채의 자유로운 사용
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 극도로 강화된 채도
  for (let i = 0; i < data.length; i += 4) {
    const max = Math.max(data[i], data[i + 1], data[i + 2]);
    if (max > 100) {
      if (data[i] === max) data[i] = 255;
      if (data[i + 1] === max) data[i + 1] = 255;
      if (data[i + 2] === max) data[i + 2] = 255;
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
};